import stringify from 'csv-stringify'
import download from 'downloadjs'

function toCSV (values) {
  var callback = function (resolve, reject) {
    return stringify(values, function (err, output) {
      if (err) {
        reject(err)
      } else {
        resolve(output)
      }
    })
  }

  return new Promise(callback)
}

export default function (columns, rows) {
  const labels = columns.map(function (c) { return c.label })
  var rawData = rows.map(function (r) {
    return columns.map(function (c) {
      return r[c.id]
    })
  })
  rawData.unshift(labels)

  toCSV(rawData).then(function(data) {
    download(data, 'report.csv', 'text/csv')
  })
}



//////////////////
// WEBPACK FOOTER
// ./~/ansergy-datatable/lib/downloadCSV.js
// module id = 41
// module chunks = 0